// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    collapsedMenus: Set<string>;
    unverifiedCount: number;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-MainLayoutSidebar',
    templateUrl: './MainLayoutSidebar.html',
    styleUrls: ['./MainLayoutSidebar.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MainLayoutSidebar extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.MainLayoutSidebar';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    var_collapsedMenus = proxySignal<Set<string>>(undefined as any);
    var_unverifiedCount = proxySignal<number>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get collapsedMenus() { return component.var_collapsedMenus() },
                set collapsedMenus(value: Set<string>) { component.var_collapsedMenus.set(value) },
                get unverifiedCount() { return component.var_unverifiedCount() },
                set unverifiedCount(value: number) { component.var_unverifiedCount.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.collapsedMenus = (new Set)
            if (!isVariablesInitialized) this.screen.unverifiedCount = (0)
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_NavigationItemBlock_74_click_toggleMenu_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_toggleMenu('finance', $event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_NavigationItemBlock_60_click_toggleMenu_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_toggleMenu('goals', $event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            screen.collapsedMenus = new Set(await This.MenuState.get() || [])
        }
    }

    async action_toggleMenu(menuName: string, $event?: any) {
        const { app, screen, output } = this
        {
            if (screen.collapsedMenus.has(menuName)) {
                screen.collapsedMenus.delete(menuName)
            } else {
                screen.collapsedMenus.add(menuName)
            }
            This.MenuState.set([...screen.collapsedMenus]).catch(() => 0)
        }
    }
}
